import { z } from 'zod';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';
import { AbstractAdditionalProperties } from './abstract-additional-properties.ts';

export const AutomaticServicePropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['AUTOMATIC_SERVICE_V1']),
});
export type AutomaticServicePropertiesV1 = z.infer<typeof AutomaticServicePropertiesSchemaV1>;
